export default {
  sendMessage: '/accounting/api/msg_send',
  getSentMessages: '/accounting/api/out_box',
  deleteMessages: '/accounting/api/msg_set_del',
  checkMessagesAsUnread: '/accounting/api/msg_set_not_read',
  checkMessagesAsRead: '/accounting/api/msg_set_read',
  getMessageById: '/accounting/api/get_message_by_id',
  getInboxMessages: '/accounting/api/in_box'
};
